import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import App from '@/App.vue'

Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.$http = axios.create({
    baseURL: '/api'
})
/*
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

Vue.prototype.$http.interceptors.request.use(request => {
        console.log("### document.cookie ", document.cookie)
        console.log("### request config ", request)

        let token = getCookie("token")

        if (token) { //getItem("token")) {
            // request.headers['Authorization'] = 'Bearer ' + store.state.token
            request.headers['Authorization'] = 'Bearer ' + token //.getItem("token")
        }
        return request
    }
)
*/

Vue.prototype.$http.interceptors.response.use(response => response,
    error => {
        console.log("### response error ", error)
        if (error.response.status === 403) {
            window.location = "https://accounts.google.com/o/oauth2/v2/auth?" +
                "response_type=code&" +
                "client_id=103887752751-2v67b29bn0tvkhue1v3l11g8seh14gcm.apps.googleusercontent.com&" +
                "scope=openid%20profile%20email&" +
                "redirect_uri=" + encodeURIComponent('https://counters.twester.ru/api/token') + '&' +
                "state=xyz&" +
                "nonce=0394852-3190485-2490358&"
        }
        return Promise.reject(error)
    }
)

function createVue() {
    let vue = new Vue({
        el: '#app',
        store,
        router,
        axios,
        vuetify,
        components: {App},
        template: '<App/>',
    })
    router.afterEach((to) => {
        vue.$emit("set-page-title", to.meta.title ?? "")
    })
/*
    vue.$http.get("/user/current").then(resp => {
        let user = resp.data
        if (user.houseId == null) {
            router.push("/profile")
        }
    })
*/
}

/*
if (window.location.pathname === "/code") {
    const code = new URLSearchParams(document.location.search).get("code")
    axios.get('/api/token?code=' + code).then(resp => {
        console.log("### user id = ", resp.data)
        // store.commit("setToken", {token: resp.data})
        localStorage.setItem("token", resp.data)
        return router.push("/")
    }).then(() => createVue())
} else {
    createVue()
}
*/
createVue()
